module.exports = __webpack_public_path__ + "ac9a93b55cb481c5953e555c34bf5f88.png";